import {ADMIN_ROLES} from "../../shared/auth/roles";

export const SUPERADMIN_ROLE = ADMIN_ROLES.SUPERADMIN;
export const ADMIN_ROLE = ADMIN_ROLES.ADMINISTRATOR;

const ONBOARDING_ROLES = new Set([SUPERADMIN_ROLE, ADMIN_ROLE]);

export const canModerateBusinessOnboarding = (role) =>
    typeof role === "string" && ONBOARDING_ROLES.has(role);
